<template>
  <transition name="confirm-fade">
    <div v-if="isShowConfirm" class="my-confirm" @click.stop="clickFun('clickCancel')">
      <div :class="['wrap', { 'container-dark': theme_dark }]" @click.stop>
        <h3 class="title">{{ titleText }}</h3>
        <div class="content">
          <div class="ub ub-ver">
            <div class="ub ub-pc ub-ac">
              <span class="mny">￥{{ content }}元</span>
            </div>
            <div class="info-block">
              <div class="ub ub-pc info-item">
                <img src="../assets/img/手机2.png" />
                <input type="text" v-model="form_data.tel" placeholder="请输入手机号码"/>
              </div>
              <div class="ub">
                <div class="ub ub-pc ub-f1 info-item">
                  <img src="../assets/img/微信2.png" />
                  <input type="text" v-model="form_data.wx_account" placeholder="请输入微信号码"/>
                </div>
              </div>
            </div>

            <div class="tips">
              <span class="txt">请务必填写正确的手机号码、微信号码，稍后会有客服添加你的微信，为你发放提现。</span>
            </div>
          </div>
          <div class="oper ub ub-ac3">
          <div v-if="type === 'confirm'" class="btn cancel ub ub-ac" @click="clickFun('clickCancel')">
            <span>{{ cancelText }}</span>
          </div>
          <div class="btn ok ub ub-ac" @click="clickFun('clickConfirm')">
            <span>{{ confirmText }}</span>
          </div>
        </div>
        </div>
        
      </div>
    </div>
  </transition>
</template>

<script>
import { mapMutations, mapActions } from "vuex";
import * as tool from "../api/common";
export default {
  data() {
    return {
      isShowConfirm: false, // 用于控制整个窗口的显示/隐藏
      titleText: "操作提示", // 提示框标题
      content: "Say Something ...", // 提示框的内容
      cancelText: "取消", // 取消按钮的文字
      confirmText: "确认", // 确认按钮的文字
      type: "confirm", // 表明弹框的类型：confirm - 确认弹窗（有取消按钮）；alert - 通知弹框（没有取消按钮）
      outerData: null, // 用于记录外部传进来的数据，也可以给外部监听userBehavior，事件的函数提供判断到底是哪个事件触发的

      img_code_url: "",
      time_sub: "获取",
      tel: "",
      img_code: "",
      msg_code: "",

      form_data: {
        real_name: "",
        zhifubao_account: "",
        wx_account: "",
        tel: "",
        tx_mny: 0,
        fee: 0,
      },
      score_left: 0,
      theme_dark: false,
      click_tag: false
    };
  },
  methods: {
    ...mapMutations(["get", "post"]), //引入方法
    ...mapActions(["act_reload_userinfo", "act_get_userinfo"]), //引入方法

    show(content, config) {
      //切换深色模式
      this.theme_dark = tool.is_theme_dark(this);
      this.content = content;

      if (Object.prototype.toString.call(config) === "[object Object]") {
        // 确保用户传递的是一个对象
        this.titleText = config.titleText || "操作提示";
        this.cancelText = config.cancelText || "取消";
        this.confirmText = config.confirmText || "确认";
        this.type = config.type || "confirm";
        this.outerData = config.data || null;
      }

      this.isShowConfirm = true;
      this.init_page();
      this.init_predata();
    },

    init_page() {
      //加载业务数据
      var self = this;
      var uid = self.$store.state.uid;
      this.act_get_userinfo({
        uid: uid,
        success: function (u) {
          self.score_left = u.score_left;
        },
      });
    },
    init_predata() {
      var uid = this.$store.state.uid;
      var self = this;
      self.get({
        url: "/App/GetTx_PreInfo/?uid=" + uid,
        success: function (u) {
          if (u) {
            self.form_data.wx_account = u.wx_account;
            self.form_data.tel = u.tel;
          }
        },
        error: function (err) {},
      });
    },

    hidden() {
      this.isShowConfirm = false;
      this.titleText = "操作提示";
      this.cancelText = "取消";
      this.confirmText = "确认";
      this.type = "confirm";
      this.outerData = null;

      this.tel = "";
      this.img_code = "";
      this.msg_code = "";
    },
    clickFun(type) {
      if (type == "clickConfirm") {
        //处理连续点击问题
        if (this.click_tag) return;
        this.click_tag = true;

        var self = this;
        setTimeout(() => {
          self.click_tag = false;
        }, 5000);

        var tel = this.form_data.tel;
        var vx = this.form_data.wx_account;
        //验证手机号码
        if (tel == "") {
          this.$toast.center("请输入手机号码");
          return false;
        }
        if (!tool.IsTelephone(tel)) {
          this.$toast.center("手机号码错误,请重新输入");
          return false;
        }

        //验证图形验证码
        if (vx == "") {
          this.$toast.center("请输入微信号码");
          return false;
        }
        this.doTixian(type);
      } else {
        this.hidden();
      }
    },

    doTixian(type) {
      var self = this;
      var uid = self.$store.state.uid;
      self.form_data.tx_mny = self.content;
      var data_send = {
        uid: uid,
        wx_account: self.form_data.wx_account,
        tel: self.form_data.tel,
        tx_mny: self.form_data.tx_mny,
        fee: (self.form_data.tx_mny * 0.2).toFixed(2),
        score_tx: self.form_data.tx_mny * 1000,
        score_left: self.score_left - self.form_data.tx_mny * 1000,
      };
      //console.log(JSON.stringify(data_send));
      self.post({
        url: "/App/ScoreTx",
        data: { uid: uid, data: JSON.stringify(data_send) },
        success: function (serve_data) {
          //处理返回结果
          self.$emit("formBehavior", type, self.outerData);
          self.hidden();

          var bll_id = serve_data.id || "";
            var msg = {
              "txt": "提现审核",
              "desc": "您的提现申请已提交,平台正在加紧为你处理,请耐心等待一下，也可尝试添加客服微信【xhczjj201712】催促一下她，添加时请备注“提现”。",
              "id": bll_id,
            }
            tool.send_check_msg(self,"check_tx",msg,true);
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.my-confirm {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 998;
  /* 这里防止当用户长按屏幕，出现的黑色背景色块，以及 iPhone 横平时字体的缩放问题 */
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

/* 进入和出去的动画 */
.confirm-fade-enter-active {
  animation: opacity 0.3s;
}

.confirm-fade-leave-active {
  animation: outOpacity 0.2s;
}
/* 进来的动画 */
@keyframes opacity {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes scale {
}

/* 出去的动画 */
@keyframes outOpacity {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

/* 包裹层容器样式 */
.wrap {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  width: 85%;
  margin: 0 auto;
  z-index: 999;
  user-select: none;
  border-radius: 1rem;
  background: linear-gradient(to bottom, #FE9CC0, #fff 3rem);
}

/* 顶部标题部分 */
.title {
    height: 3rem;
    line-height: 3rem;
    text-align: center;
    font-size: 1rem;
    font-weight: bold;
    color: #6C1AAB;
}

/* 中间内容部分 */
.content {
  padding: 0 0.8rem 1rem 0.8rem;
  line-height: 1.6rem;
  font-size: 0.9rem;
  color: #666;
  .info-block {
    padding: 0.4rem;
    margin-bottom: 0.5rem;
    .info-item {
      padding: 0.2rem 0.8rem;
      border: 1px solid #9dcef7;
      height: 2rem;
      margin-bottom: 1rem;
      border-radius: 0.3rem;
      img {
        width: 1.6rem;
        height: 1.5rem;
      }
      input {
        background-color: transparent;
        margin-left: 0.8rem;
        border: 0;
        outline: 0;
        font-size: 0.85rem;
      }
    }
  }
  .tips {
    padding: 0 0.4rem;
  }
  .mny {
      margin: 0.5rem 0;
      font-size: 1.5rem;
      color: #e92162;
      font-weight: 600;
  }
  .txt {
    font-size: 0.85rem;
    color: #fc4e09;
    line-height: 1.6rem;
  }
  /* 底部按钮样式 */
  .oper {
    margin-top: 1.5rem;
    .btn {
      margin: 0 0.5rem;
      flex: 1;
      border-radius: 2rem;
    }
    .ok {
      
      background: linear-gradient(90deg, #a264e7, #fe9cc0);
      
    }
    .cancel {
      color: #ffffff;
      background-color: #c1c1c1;
    }
    span {
        line-height: 2.6rem;
        color: #fff;
      }
  }
}


.container-dark {
  background: linear-gradient(to bottom, #9c365c, #333 3rem);
  .title {
    color: #fff;
  }
  .mny {
    color: rgb(186, 97, 255);
  }
  .txt {
    color: rgb(186, 97, 255);
  }
  .content {
       .info-block {
        .info-item {
            border: 1px solid #666;
            input {
            color: #999;
          }
        }
      }
     }
}
</style>